// extracted by mini-css-extract-plugin
export var box = "styles-module--box--3ECI0";
export var titleStyle = "styles-module--titleStyle--_mZ6E";
export var image = "styles-module--image--2DS8L";
export var about = "styles-module--about--3-4OG";
export var dateStyle = "styles-module--dateStyle--38bBm";